import React from "react";
import { Route, Switch } from "react-router-dom";
import ProtectedRoute from "../routes-nav/ProtectedRoute";
import HomePage from "../homepage/HomePage";
import About from "../homepage/About";
import AddLocationForm from "../forms/AddLocationForm";
import AddRegionForm from "../forms/AddRegionForm";
import AddPodiumForm from "../forms/AddPodiumForm";
import NewAddVehicleForm from "../forms/NewAddVehicleForm";
import DamagesForm from "../forms/DamagesForm";
import ValidUpdateProfileForm from "../forms/ValidUpdateProfileForm";
import ValidLoginForm from "../auth/ValidLoginForm";
import TenantValidationLoginForm from "../auth/TenantValidationLoginForm";
import TenantPortalHomePage from "../auth/TenantPortalHomePage";
import ForgotPasswordForm from "../auth/ForgotPasswordForm";
import ResetPasswordForm from "../auth/ResetPasswordForm";
import ValetRegisterForm from "../forms/ValetRegisterForm";
import ValidRegisterForm from "../auth/ValidRegisterForm";
import GenerateInviteForm from "../forms/GenerateInviteForm";
import GarageList from "../transactions/GarageList";
import GarageDetail from "../transactions/GarageDetail";
import UserLocationDetail from "../location/UserLocationDetail";
import Dashboard from "../charts/Dashboard";
import ValetDashBoard from "../dashboard/ValetDashBoard";
import Graph from "../charts/Graph";
import PodiumDetail from "../podium/PodiumDetail";
import CustomerVehicleInfo from "../messaging/CustomerVehicleInfo";
import UserConfig from "../auth/UserConfig";
import PaymentPricingConfigPage from "../auth/PaymentPricingConfigPage";
import PaymentRevenueReportsPage from "../auth/PaymentRevenueReportsPage";
import ValidationTenantsPage from "../auth/ValidationTenantsPage";
import ValidationRedeemPage from "../auth/ValidationRedeemPage";
import ValidationReportsPage from "../auth/ValidationReportsPage";
import AdminSetup from "../auth/AdminSetup";
import AppSettingsPage from "../settings/AppSettingsPage";
import PodiumSelector from "../components/PodiumSelector";
import CustomerSurveyPage from "../messaging/CustomerSurveyPage";
import SurveyGraph from "../charts/SurveyGraph";
import PrivacySmsPolicy from "../homepage/PrivacySmsPolicy";
import PrivacyPolicy from "../homepage/PrivacyPolicy";
import TicketQrPrintPage from "../utility/TicketQrPrintPage";
import SmsTerms from "../homepage/SmsTerms";
import ElectronicTipWalletPage from "../tips/ElectronicTipWalletPage";

import NotFound from "./NotFound";

const Routes = () => {
    return (
        <Switch>
            <Route
                exact
                path="/">
                <HomePage />
            </Route>

            <Route
                exact
                path="/login">
                <ValidLoginForm />
            </Route>

            <Route
                exact
                path="/tenant/login">
                <TenantValidationLoginForm />
            </Route>

            <ProtectedRoute
                exact
                path="/tenant/portal"
                allowedRoles={[0]}
                component={TenantPortalHomePage}
            />

            <Route
                exact
                path="/forgot-password">
                <ForgotPasswordForm />
            </Route>

            <Route
                exact
                path="/reset-password">
                <ResetPasswordForm />
            </Route>

            <Route
                exact
                path="/registerWithInvite">
                <ValetRegisterForm />
            </Route>

            <Route
                exact
                path="/about">
                <About />
            </Route>

            <Route
                exact
                path="/updateProfile">
                <ValidUpdateProfileForm />
            </Route>

            <Route
                exact
                path="/addVehicle">
                <NewAddVehicleForm />
            </Route>

            <Route
                exact
                path="/terms">
                <SmsTerms />
            </Route>

            <Route
                exact
                path="/privacy-sms-policy">
                <PrivacySmsPolicy />
            </Route>

            <Route
                exact
                path="/privacy-policy">
                <PrivacyPolicy />
            </Route>

            <ProtectedRoute
                exact
                path="/admin/tickets/print"
                allowedRoles={[2, 3, 4, 5]}
                component={TicketQrPrintPage}
            />

            <ProtectedRoute
                exact
                path="/addRegion"
                allowedRoles={[4, 5]}
                component={AddRegionForm}
            />

            <ProtectedRoute
                exact
                path="/addLocation"
                allowedRoles={[4, 5]}
                component={AddLocationForm}
            />

            <ProtectedRoute
                exact
                path="/addPodium"
                allowedRoles={[4, 5]}
                component={AddPodiumForm}
            />

            <ProtectedRoute
                exact
                path="/register"
                allowedRoles={[3, 4, 5]}
                component={ValidRegisterForm}
            />

            <Route
                exact
                path="/survey/customer/:token">
                <CustomerSurveyPage />
            </Route>

            <Route
                exact
                path="/customers/:ticketNum/:customerToken">
                <CustomerVehicleInfo />
            </Route>

            <Route
                exact
                path="/damages">
                <DamagesForm />
            </Route>

            <ProtectedRoute
                exact
                path="/user/config"
                allowedRoles={[3, 4, 5]}
                component={UserConfig}
            />

            <ProtectedRoute
                exact
                path="/settings"
                allowedRoles={[1, 2, 3, 4, 5]}
                component={AppSettingsPage}
            />

            <ProtectedRoute
                exact
                path="/tips/electronic"
                allowedRoles={[1, 2, 3]}
                component={ElectronicTipWalletPage}
            />

            <ProtectedRoute
                exact
                path="/payments/config"
                allowedRoles={[3, 4, 5]}
                component={PaymentPricingConfigPage}
            />

            <ProtectedRoute
                exact
                path="/payments/reports"
                allowedRoles={[3, 4, 5]}
                component={PaymentRevenueReportsPage}
            />

            <ProtectedRoute
                exact
                path="/validations"
                allowedRoles={[0, 3, 4, 5]}
                component={ValidationTenantsPage}
            />

            <ProtectedRoute
                exact
                path="/validations/tenants"
                allowedRoles={[0, 3, 4, 5]}
                component={ValidationTenantsPage}
            />

            <ProtectedRoute
                exact
                path="/validations/redeem"
                allowedRoles={[0, 1, 2, 3, 4, 5]}
                component={ValidationRedeemPage}
            />

            <ProtectedRoute
                exact
                path="/validations/reports"
                allowedRoles={[0, 3, 4, 5]}
                component={ValidationReportsPage}
            />

            <ProtectedRoute
                exact
                path="/admin/setup"
                allowedRoles={[3, 4, 5]}
                component={AdminSetup}
            />

            <ProtectedRoute
                exact
                path="/surveyGraph"
                allowedRoles={[2, 3, 4, 5]}
                component={SurveyGraph}
            />

            <ProtectedRoute
                exact
                path="/valetDashBoard"
                allowedRoles={[1, 2, 3, 4, 5]}
                component={ValetDashBoard}
            />
            <ProtectedRoute
                exact
                path="/garage"
                allowedRoles={[1, 2, 3, 4, 5]}
                component={GarageList}
            />

            <ProtectedRoute
                exact
                path="/dashboard"
                allowedRoles={[2, 3, 4, 5]}
                component={Dashboard}
            />

            <ProtectedRoute
                exact
                path="/admin/invite"
                allowedRoles={[3, 4, 5]}
                component={GenerateInviteForm}
            />

            <ProtectedRoute
                exact
                path="/selectPodium"
                allowedRoles={[1, 2, 3, 4, 5]}
                component={PodiumSelector}
            />

            <ProtectedRoute
                exact
                path="/graph"
                allowedRoles={[2, 3, 4, 5]}
                component={Graph}
            />

            <ProtectedRoute
                exact
                path="/podiums/id/:id"
                allowedRoles={[1, 2, 3, 4, 5]}
                component={PodiumDetail}
            />

            <ProtectedRoute
                exact
                path="/transactions/active"
                allowedRoles={[1, 2, 3, 4, 5]}
                component={GarageList}
            />

            <ProtectedRoute
                exact
                path="/transactions/id/:vehicleId"
                allowedRoles={[1, 2, 3, 4, 5]}
                component={GarageDetail}
            />

            <ProtectedRoute
                exact
                path="/garage/podiumId/:podiumId"
                allowedRoles={[1, 2, 3, 4, 5]}
                component={GarageDetail}
            />

            <ProtectedRoute
                exact
                path="/locations"
                allowedRoles={[1, 2, 3, 4, 5]}
                component={UserLocationDetail}
            />

            <Route>
                <NotFound />
            </Route>
        </Switch>
    );
};

export default Routes;
